import React from "react";

import { SignIn } from "aws-amplify-react";

import {
  Card,
  CardContent,
  Button,
  ButtonBase,
  Input,
  InputAdornment,
  IconButton,
  InputLabel,
  FormControl,
  FormHelperText,
  Typography,
  createTheme,
  MuiThemeProvider,
} from "@material-ui/core";

import { Visibility, VisibilityOff } from "@material-ui/icons";

import customTheme from "./themes/customTheme";

import { withStyles } from "@material-ui/core/styles";
import { styles } from "./CustomSignIn.styles";
import { ReactComponent as ClioIcon } from "./icons/clio_white_icon.svg";

const theme = createTheme(customTheme);

class MySignIn extends SignIn {
  state = {
    showPassword: false,
  };

  forgotPasswordClick = () => this.changeState("forgotPassword");
  createAccountClick = () => this.changeState("signUp");
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (this.inputs?.password?.length > 0) {
        this.signIn();
      } else {
        alert("No password entered !");
      }
    }
  };

  handleSignIn = (event) => {
    if (this.inputs?.password?.length > 0) {
      this.signIn();
    } else {
      alert("No password entered !");
    }
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  showComponent() {
    const { showPassword } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <MuiThemeProvider theme={theme}>
          <Card className={classes.card} raised={false} onKeyPress={this.handleKeyDown}>
            <CardContent className={classes.cardContent}>
              <span className={classes.logo}>
                <img className={classes.logoImage} src="/img/puzzle-200px.svg" alt="company-logo"></img>
                <span className={classes.logoText}>
                  <span className={classes.logoFont} style={{ color: "#5e6fa3" }}>
                    Report
                  </span>
                  <span className={classes.logoFont} style={{ color: "#93dbe9" }}>
                    Zone
                  </span>
                </span>
              </span>
              <Typography variant="h5" align="center" paragraph>
                Sign in
              </Typography>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="username">Username</InputLabel>
                <Input
                  className={classes.textfield}
                  autoFocus
                  id="username"
                  label="Username"
                  inputProps={{
                    key: "username",
                    name: "username",
                  }}
                  onChange={this.handleInputChange}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input
                  className={classes.textfield}
                  id="password"
                  inputProps={{
                    key: "password",
                    name: "password",
                  }}
                  onChange={this.handleInputChange}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />

                <FormHelperText className={classes.textHelper}>
                  Forgot your password ?
                  <ButtonBase className={classes.buttonLink} onClick={this.forgotPasswordClick}>
                    Reset Password
                  </ButtonBase>
                </FormHelperText>
                <FormHelperText className={classes.textHelper}>
                  No Account ?
                  <ButtonBase className={classes.buttonLink} onClick={this.createAccountClick}>
                    Create Account
                  </ButtonBase>
                </FormHelperText>
              </FormControl>
              <Button
                data-testid="SignInButton"
                className={classes.button}
                type="submit"
                variant="contained"
                onClick={this.handleSignIn}
              >
                Sign In
              </Button>
              {false ? (
                <Button
                  size="small"
                  data-testid="SignInButton"
                  className={classes.clioButton}
                  type="submit"
                  variant="contained"
                  tabindex="0"
                  href="https://account.clio.com/oauth2/auth?response_type=code&client_id=1149587a-4510-4798-b525-0dc4fe26953d&scope=openid&state=12345678&redirect_uri=https://report-zone.auth.us-east-1.amazoncognito.com/oauth2/idpresponse"
                  startIcon={<ClioIcon width={16} height={16} />}
                >
                  Sign in with Clio
                </Button>
              ) : null}
            </CardContent>
          </Card>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withStyles(styles, { theme: true })(MySignIn);
